import { stats, siteInfo } from '@/mocks/incidents';

export default function StatsBand() {
  return (
    <section className="w-full bg-foreground-950">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:items-center">
          <div className="lg:col-span-4">
            <span className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-accent-400">
              <span className="h-1 w-6 rounded-full bg-accent-500"></span>
              收录概览
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              用可检索的方式，
              <br className="hidden md:block" />
              把零散信息沉淀下来
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              {siteInfo.name}将分散在各处的公开报道按主题与时间归档，方便读者回看某起事件的来龙去脉，也方便做反诈宣传时快速取用素材。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4 lg:col-span-8 lg:grid-cols-4 lg:gap-6">
            {stats.map((item) => (
              <div key={item.label} className="rounded-lg border border-secondary-800 bg-secondary-950/60 p-4 md:p-5">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600/20 text-accent-400">
                  <i className={`${item.icon} text-lg`}></i>
                </span>
                <p className="mt-4 flex items-baseline gap-1 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                  {item.value}
                  <span className="text-xs font-normal text-background-400">{item.unit}</span>
                </p>
                <p className="mt-1 text-xs leading-relaxed text-background-300">{item.label}</p>
              </div>
            ))}
          </div>
        </div>

        <p className="mt-8 border-t border-secondary-800 pt-5 text-[11px] text-background-400">
          数据为站内条目收录量统计，随内容更新动态变化，用于说明内容沉淀规模，不作为任何官方数据引用。
        </p>
      </div>
    </section>
  );
}